export default "__VITE_ASSET__79e604a5__"